goog.provide("shadow.js.shim.module$dayjs$plugin$localeData");
goog.provide("module$shadow_js_shim_module$dayjs$plugin$localeData");
shadow.js.shim.module$dayjs$plugin$localeData = shadow.js.nativeProvides["dayjs/plugin/localeData"] = require("dayjs/plugin/localeData");
module$shadow_js_shim_module$dayjs$plugin$localeData.default = shadow.js.shim.module$dayjs$plugin$localeData;
